import React from 'react';
import { getInitials, getAvatarColor } from '../../utils/helpers';

export default function Avatar({ user, size = 48, className = '' }) {
  const style = {
    width: size, height: size, borderRadius: '50%',
    background: getAvatarColor(user?.name),
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: size * 0.33, fontWeight: 700, color: 'white',
    flexShrink: 0, objectFit: 'cover',
  };

  if (user?.avatar) {
    return (
      <img
        src={user.avatar}
        alt={user.name}
        className={className}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
        onError={e => {
          e.target.style.display = 'none';
          e.target.nextSibling && (e.target.nextSibling.style.display = 'flex');
        }}
      />
    );
  }

  return (
    <div className={className} style={style}>
      {getInitials(user?.name || '?')}
    </div>
  );
}
